// import "babel-polyfill"
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import filter from '../libs/filterall';
// 全局样式
import "../style/elcommon.scss";
// 全局导入过滤器
Object.keys(filter).forEach(key => Vue.filter(key, filter[key]))
// 通用请求
import fetch from '../api/httpFetch'
import { fetchGet } from "../libs/reqCommon"
window.fetch = fetch;
Vue.use(ElementUI);

//引入图片预览插件
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})
// 这里是插件的默认设置↑

import Vue2OrgTree from 'vue2-org-tree' //树形组织结构图插件
Vue.use(Vue2OrgTree)
// 将自动注册所有组件为全局组件
import dataV from '@jiaminghi/data-view'
Vue.use(dataV)

// 处理菜单,获取非文件夹菜单
function handleMenus(menus, result) {
  for (let i = 0; i < menus.length; i++) {
    if (menus[i].leaf || menus[i].children.length == 0) result.push(menus[i])
    else if (menus[i].children.length > 0)
      handleMenus(menus[i].children, result);
  }
};

function createRouter(menuList, result) {
  // 节点数据，生成一个只包含叶子节点的数组 menusForSearch
  handleMenus(menuList, result.menusForSearch);
  // 动态路由
  for (let item of result.menusForSearch) {
    let index = item.index;
    var r = {
      name: item.id,
      path: item.page,
      component: item.modelname ?
        () => import("../views/" + item.modelname) :
        () => import("../components/error404"),
      meta: {
        index: index,
        name: item.name,
        modelname: item.modelname,
        resource: item.resource ? item.resource : []
      }
    }
    result.router[0].children.unshift(r)
  }
}

// 获取菜单数据
var a = [];
function getMenuList() {
  return new Promise((r, j) => {
    fetchGet("/hcm/getMenuListByUser").then(data => {
      if (data.status == '10000') {
        a = [];
        data.data.forEach((item, i) => {
          let obj = {
            children: []
          }
          obj.id = "menu" + item.id
          obj.name = item.menuName
          obj.leaf = false
          obj.icon = item.menuIcon
          obj.modelname = item.modulename ? item.modulename.slice(2) : false
          obj.page = item.routePath
          obj.expand = false
          obj.hide = parseInt(item.menuState)
          obj.index = i
          if (item.children) {
            for (let childs of item.children) {
              let obj1 = {}
              obj1.id = "menu" + childs.id
              obj1.name = childs.menuName
              obj1.leaf = true
              obj1.index = i
              obj1.modelname = childs.modulename.slice(2)
              obj1.page = childs.routePath
              obj1.hide = parseInt(childs.menuState)
              obj.children.push(obj1)
              obj1.smallChildren = childs.children
            }
          }
          a.push(obj)
        })
        r(a);
      } else {
        j(data);
      }
    }).catch((data) => {
      j(data);
    });
  })

}


// // 其他静态路由
var others = [
  {
    path: "/home",
    name: "home",
    component: () => import('views/home'),
    children: [
      {
        path: '/updateProcess',
        name: 'updateProcess',
        component: () => import('views/Brand/BrandMerchandise/updateProcess.vue'),
      },
      {
        path: '/keywordPdd',
        name: 'keywordPdd',
        component: () => import('views/Brand/BrandMerchandise/keywordPdd.vue'),
      },
      {
        path: '/retrievalTask',
        name: 'retrievalTask',
        component: () => import('views/Brand/BrandMerchandise/retrievalTask.vue'),
      },
      {
        path: '/lowPriceDetails',
        name: 'lowPriceDetails',
        component: () => import('views/Brand/BrandMerchandise/lowPriceDetails.vue'),
      },
      {
        path: '/searchCriteriaSetting',
        name: 'searchCriteriaSetting',
        component: () => import('views/Brand/BrandMerchandise/searchCriteriaSetting.vue'),
      },
      {
        path: '/dynamicForm',
        name: 'dynamicForm',
        component: () => import('views/systemSetupList/dynamicForm.vue'),
      },
      {
        path: "/homeInterim",
        name: "homeInterim",
        component: () => import('views/homeInterim'),
      },
      {
        path: '/addMain',
        name: 'addMain',
        component: () => import('views/Brand/floatingPlaten/addMain.vue'),
      },
      {
        path: '/rectificationTime',
        name: 'rectificationTime',
        component: () => import('views/systemSetupList/rectificationTime.vue'),
      },
      {
        path: '/activityDeclarationSettings',
        name: 'activityDeclarationSettings',
        component: () => import('views/systemSetupList/activityDeclarationSettings.vue'),
      },
      {
        path: '/activityChecking',
        name: 'activityChecking',
        component: () => import('views/systemSetupList/activityChecking.vue'),
      },

      {
        path: '/BrandSet',
        name: 'BrandSet',
        component: () => import('views/externalUsers/BrandSet.vue'),
      },
      {
        path: '/adminHomepage',
        name: 'adminHomepage',
        component: () => import('views/homePage/adminHomepage.vue'),
      },
      {
        path: '/BrandHomepage',
        name: 'BrandHomepage',
        component: () => import('views/homePage/BrandHomepage.vue'),
      },
      {
        path: '/brmHomepage',
        name: 'brmHomepage',
        component: () => import('views/homePage/brmHomepage.vue'),
      },
      {
        path: '/changeHistory',
        name: 'changeHistory',
        component: () => import('views/ChannelPolicy/changeHistory.vue'),
      },
      {
        path: '/productInformation',
        name: 'productInformation',
        component: () => import('views/ChannelPolicy/productInformation.vue'),
      },
      {
        path: '/newAdd',
        name: 'newAdd',
        component: () => import('views/ChannelPolicy/newAdd.vue'),
      },
      {
        path: '/TheEditor',
        name: 'TheEditor',
        component: () => import('views/ChannelPolicy/TheEditor.vue'),
      },
      {
        path: '/productHistory',
        name: 'productHistory',
        component: () => import('views/ChannelPolicy/productHistory.vue'),
      },
      {
        path: '/allProductHistory',
        name: 'allProductHistory',
        component: () => import('views/ChannelPolicy/allProductHistory.vue'),
      },
      {
        path: '/wechatBind',
        name: 'wechatBind',
        component: () => import('views/login/wechatBind.vue'),
      },
      {
        path: '/newAddAnnouncement',
        name: 'newAddAnnouncement',
        component: () => import('views/Announcements/newAddAnnouncement.vue'),
      },
      {
        path: '/AnnouncementDetails',
        name: 'AnnouncementDetails',
        component: () => import('views/Announcements/AnnouncementDetails.vue'),
      },
      {
        path: '/addMonitorPlan/:id',
        name: 'addMonitorPlan',
        component: () => import('views/Brand/MonitorPlan/addMonitorPlan.vue'),
      },
      {
        path: '/newLink',
        name: 'newLink',
        component: () => import('views/Brand/UrlMonitor/newLink.vue'),
      },
      {
        path: '/MonitorHistory',
        name: 'MonitorHistory',
        component: () => import('views/Brand/UrlMonitor/MonitorHistory.vue'),
      },
      {
        path: '/allMonitorHistory',
        name: 'allMonitorHistory',
        component: () => import('views/Brand/UrlMonitor/allMonitorHistory.vue'),
      },
      {
        path: '/urlMonitorDetails',
        name: 'urlMonitorDetails',
        component: () => import('views/Brand/UrlMonitor/urlMonitorDetails.vue'),
      },
      {
        path: '/NewFeedback',
        name: 'NewFeedback',
        component: () => import('views/PersonalCenter/NewFeedback.vue'),
      },
      {
        path: '/InfoItem/:type/:id',
        name: 'InfoItem',
        component: () => import('views/Brand/AccountManagement/InfoItem.vue'),
      },
      {
        path: '/feedbackDetilis',
        name: 'feedbackDetilis',
        component: () => import('views/PersonalCenter/feedbackDetilis.vue'),
      },
      {
        path: '/priceControlBoard',
        name: 'priceControlBoard',
        component: () => import('views/Service/priceControlBoard/main.vue'),
      },
      {
        path: '/priceSize',
        name: 'priceSize',
        component: () => import('views/priceSize.vue'),
      },
      {
        path: '/kanbanDataDetil',
        name: 'kanbanDataDetil',
        component: () => import('views/Service/kanbanDataDetil/main.vue'),
      },
      {
        path: '/ChannelOverview',
        name: 'ChannelOverview',
        component: () => import('views/Brand/ChannelOverview/main.vue'),
      },
      {
        path: '/dealers',
        name: 'dealers',
        component: () => import('views/Dealers/Home/main.vue'),

      },
      {
        // path: '/activityApprovalSetting/:id',
        path: '/activityApprovalSetting',
        name: 'activityApprovalSetting',
        component: () => import('views/systemSetupList/activityApprovalSetting.vue'),
      },
      {
        path: '/brandPartySetting',
        name: 'brandPartySetting',
        component: () => import('views/systemSetupList/brandPartySetting.vue'),
      },
      {
        path: '/pasadyangSeting',
        name: 'pasadyangSeting',
        component: () => import('views/systemSetupList/pasadyangSeting.vue'),
      },
      {
        path: '/brandPartyAdd',
        name: 'brandPartyAdd',
        component: () => import('views/systemSetupList/brandPartyAdd.vue'),
      },
      {
        path: '/ComplaintDownloadList',
        name: '/ComplaintDownloadList',
        component: () => import('views/Service/ComplaintDownloadList/ComplaintDownloadList.vue'),
      },
      {
        path: '/OutNotificationDetail/:time',
        name: 'OutNotificationDetail',
        component: () => import('views/Brand/BrandMerchandise/OutNotificationDetail.vue'),
      },
      {
        path: '/ComplaintDetail',
        name: 'ComplaintDetail',
        component: () => import('views/Brand/BrandMerchandise/ComplaintDetail.vue'),
      },
      {
        path: '/activityPublicitySet',
        name: 'activityPublicitySet',
        component: () => import('views/systemSetupList/activityPublicity/main.vue'),
      },
      {
        path: '/dataInformationsEdit',
        name: 'dataInformationsEdit',
        component: () => import('views/Shop/DataInformations/edit/index.vue'),
      },
      {
        path: '/InformationMain',
        name: 'InformationMain',
        component: () => import('views/Shop/DataInformations/main.vue'),
      },
      {
        path: '/dealersDataInformationsEdit',
        name: 'dealersDataInformationsEdit',
        component: () => import('views/Dealers/DataInformation/edit/index.vue'),
      },
      {
        path: '/reportDeal',
        name: 'reportDeal',
        component: () => import('views/Service/ServiceReport/reportDeal.vue'),
      }, {
        path: '/CreditScoreSets',
        name: 'CreditScoreSets',
        component: () => import('views/CreditScore/CreditScoreSet/set'),
      },
      {
        path: '/NewNoticeReview',
        name: 'NewNoticeReview',
        component: () => import('views/Service/ViolationNoticeReview/NewNoticeReview.vue'),
      },
      {
        path: '/monitorPlanDeal',
        name: 'monitorPlanDeal',
        component: () => import('views/Brand/MonitorPlan/monitorPlanDeal')
      },
      {
        path: '/activityDetail/:id',
        name: 'activityDetail',
        component: () => import('views/Brand/ActivityApproval/activityDetail')
      },
      {
        path: '/monitoringProducts',
        name: 'monitoringProducts',
        component: () => import('views/Brand/MonitorCenter/monitoringProducts.vue'),
      },
      {
        path: '/monitoringStore',
        name: 'monitoringStore',
        component: () => import('views/Brand/MonitorCenter/MonitorStore/monitoringStore.vue'),
      },
      {
        path: '/monitoringLink',
        name: 'monitoringLink',
        component: () => import('views/Brand/MonitorCenter/LinkMonitor/monitoringLink.vue'),
      },
      {
        path: '/linkDetails',
        name: 'linkDetails',
        component: () => import('views/Brand/MonitorCenter/LinkMonitor/linkDetails.vue'),
      },
      {
        path: '/storeDetails',
        name: 'storeDetails',
        component: () => import('views/Brand/MonitorCenter/MonitorStore/storeDetails.vue'),
      },
      {
        path: '/MonitorDetails',
        name: 'MonitorDetails',
        component: () => import('views/Brand/MonitorCenter/MonitorDetails.vue'),
      },
      {
        path: '/AddLink',
        name: 'AddLink',
        component: () => import('views/Brand/MonitorCenter/AddLink/index.vue'),
      },
      {
        path: '/releaseMess',
        name: 'releaseMess',
        component: () => import('views/Message/MessageCenter/releaseMess.vue'),
      },
      {
        path: '/MessageCenter/:id',
        name: 'MessageCenter',
        component: () => import('views/Message/MessageCenter/main.vue')
      },
      {
        path: '/addMessage',
        name: 'addMessage',
        component: () => import('views/Service/addMessage.vue'),
      },
      {
        path: '/custormTable/addTable',
        name: 'addTable',
        component: () => import('views/Brand/BrandMerchandise/addTable.vue')
      },
      {
        path: '/custormTable/addTable/:id',
        name: 'addTable',
        component: () => import('views/Brand/BrandMerchandise/addTable.vue')
      },
      {
        path: '/custormTable/previewTable',
        name: 'previewTable',
        component: () => import('views/Brand/BrandMerchandise/previewTable.vue')
      },
      {
        path: '/custormTable/exportTable',
        name: 'exportTable',
        component: () => import('views/Brand/BrandMerchandise/exportTable.vue')
      },
      {
        path: '/salesRegistration/buyingHistory',
        name: 'buyingHistory',
        component: () => import('views/salesRegistration/buyingHistory/index.vue')
      }
    ],
  },
  {
    path: '/login/:type?',
    name: 'login',
    component: () => import('views/login/login.vue'),
  },
  {
    path: '/wechatLogin',
    name: 'wechatLogin',
    component: () => import('views/login/wechatLogin.vue'),
  },
  {
    path: '/findpwd',
    name: 'findpwd',
    component: () => import('views/login/findpwd.vue'),
  },
  {
    path: '/InitialSystem/main/',
    name: 'initialSystem',
    component: () => import('views/InitialSystem/main.vue'),
  },
  {
    path: '/weChatChat',
    name: 'weChatChat',
    component: () => import('views/NotificationPublic/weChat/index.vue'),
  },
  {
    path: '/screenshotH5',
    name: 'screenshotH5',
    component: () => import('views/screenshotH5.vue'),
  },
  {
    path: '/dataSize',
    name: 'dataSize',
    component: () => import('views/dataSize.vue'),
  },
  {
    path: '/diagnosis',
    name: 'ChannelDiagnosis',
    component: () => import('views/diagnosis/index.vue'),
    meta: { title: '渠道结构健康诊断', requiresAuth: true }
  }
];
// 菜单数据
export const getRouter = function () {
  // TODO 可以使用异步请求请求菜单数据 menusFromBack
  return new Promise((r, j) => {
    if (!localStorage.getItem('token')) {
      let result = {
        // 菜单数据
        menus: [],
        // 节点数据
        menusForSearch: [],
        // 路由
        router: others
      }
      createRouter([], result); j
      j(result)
    } else {
      getMenuList().then((menuList) => {
        // 返回值
        let result = {
          // 菜单数据
          menus: menuList,
          // 节点数据
          menusForSearch: [],
          // 路由
          router: others
        }
        createRouter(menuList, result);
        r(result)
      }).catch((res) => {
        let result = {
          // 菜单数据
          menus: [],
          // 节点数据
          menusForSearch: [],
          // 路由
          router: others
        }
        createRouter([], result);
        j(result)
      })
    }
  })
}

//静态路由 以为.static.vue结尾
let file = require.context('../views', true, /\.static.vue$/)
file.keys().forEach(item => {
  let path = item.substring(item.lastIndexOf('/'), item.length - 11)
  others[0].children.push(
    {
      path,
      name: path.substring(1, path.length),
      component: () => import('views/' + item.slice(2, item.length)),
    }
  )
})
